import { IProject } from "./projectReducer";

export function setActiveProject(project: IProject) {
    return {
        type: "UPDATE_PROJECT",
        payload: project
    }
}